import React from "react"
import { Typography, Box, useTheme } from "@mui/material"
import { Image } from "components/Image"

export const MovieHeader = ({ title, logo, genre, duration }) => {
  const theme = useTheme()
  const styleOverrides = theme.components[`MovieHeader`]?.styleOverrides || {}
  const {
    root,
    cinemaLogo,
    titleTypography,
    titleContainer,
    genreTypography,
    bodyTypography,
    genreDurationContainer,
  } = styleOverrides

  return (
    <Box sx={root}>
      <Image src={logo} sx={cinemaLogo} />
      <Box sx={titleContainer}>
        <Typography sx={titleTypography}>{title}</Typography>
        <Box sx={genreDurationContainer}>
          <Typography sx={genreTypography}>{genre}</Typography>
          <Typography sx={bodyTypography}>{duration}</Typography>
        </Box>
      </Box>
    </Box>
  )
}
